<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeDialog"
      width="1200px"
    >
      <div class="dialog-content lg">
          <table border="1" borderColor="" align="center"  width="100%">
            <tr align="center" height="50" v-if="viewData&&viewData.length">
                <td width="100" style="font-size: 14px;font-weight: 600;background: #f3f8ff;">产品名称</td>
                <td width="100"  style="font-size: 14px;font-weight: 600;background: #f3f8ff;" v-for="(item,index) in  viewData">{{ item.cpmc }}</td>
            </tr>
            <tr align="center" height="50" v-if="viewData&&viewData.length">
                <td style="font-size: 14px;font-weight: 600;background: #f3f8ff;">利率范围</td>
                <td width="100" v-for="(item,index) in  viewData">{{  item.zdnhlv+"-"+item.zgnhlv  +' %'  }}</td>
            </tr>
            <tr align="center" height="50" v-if="viewData&&viewData.length">
                <td style="font-size: 14px;font-weight: 600;background: #f3f8ff;">贷款期限</td>
                <td width="100" v-for="(item,index) in  viewData">{{ item.dkqxxx+"-"+item.dkqxsx  +' 个月' }}</td>
            </tr>
            <tr align="center" height="50" v-if="viewData&&viewData.length">
                <td style="font-size: 14px;font-weight: 600;background: #f3f8ff;">贷款额度</td>
                <td width="100" v-for="(item,index) in  viewData">{{ item.dkedxx+"-"+item.dkedsx +' 万' }}</td>
            </tr>
            <tr align="center" height="50" v-if="viewData&&viewData.length">
                <td style="font-size: 14px;font-weight: 600;background: #f3f8ff;">担保类型</td>
                <td width="100" v-for="(item,index) in  viewData">{{ item.dbfsm }}</td>
            </tr>
            <tr align="center" height="130" v-if="viewData&&viewData.length">
                <td style="font-size: 14px;font-weight: 600;background: #f3f8ff; overflow: hidden;">产品描述</td>
                <td width="100" v-for="(item,index) in  viewData">{{ item.cpms }}</td>
            </tr>
          </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'Dialog',
  props: ['showDialog', 'dialogTitle', 'viewData'],
  data () {
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
    }
  },
  created () {
    if (this.viewData&&this.viewData.id) {
    }
  },
  mounted() {

  },
  methods: {

    // 提交
    async submit () {
      if (!validateForm(this.$refs["form"])) {
        message = "表单信息缺失。";
        this.$baseMessage(message, "error");
        return;
      }
      let res = {}
      let message = ''
      if (this.viewData&&this.viewData.id) {
        this.form.id = this.viewData.id;
        res = await editProduct(this.form)
        message = '修改成功。'
      } else {
        res = await addProduct(this.form)
        message = '新增成功。'
      }
      this.$baseMessage(message, 'success')
      this.$emit('closeDialog', true)
    },
    closeDialog () {
      this.$emit('closeDialog')
    }

  }
}
</script>
<style scoped>
td{
  border: 1px solid #e5eefb;
  display: table-cell;
  vertical-align: middle;
}
</style>
